import { PostOptionsModalType } from "../ServiceModal.types";
import { ServiceModalInnerContainerStyles } from "../ServiceModal.styles";
import { ModalConstructor } from "../../ModalConstructor";
import { useEffect } from "react";
import PostOptionsModalState from "./PostOptionsModalState";
import { SELF_CLOSING_MODAL_TIMEOUT_TIME_TO_CLOSE } from "../../ServiceFunctionsModal.types";

export function PostOptionsModal(postOptionsModalProps: PostOptionsModalType) {
    const modalProps = PostOptionsModalState({
        ...postOptionsModalProps,
    });
    function handleClosingCurrentModal() {
        postOptionsModalProps.setOpen(false);
        postOptionsModalProps.onClose?.();
    }

    useEffect(() => {
        if (modalProps?.autoClosingModal) {
            const timeoutId = setTimeout(() => {
                handleClosingCurrentModal();
            }, SELF_CLOSING_MODAL_TIMEOUT_TIME_TO_CLOSE);

            return () => {
                clearTimeout(timeoutId);
            };
        }
    }, [postOptionsModalProps.modalCurrentAction]);

    useEffect(() => {
        return () => {
            handleClosingCurrentModal();
        };
    }, []);

    return (
        <ModalConstructor
            onClose={handleClosingCurrentModal}
            open={postOptionsModalProps.open}
            modalContent={modalProps?.modalContent && modalProps.modalContent}
            modalActions={modalProps?.modalActions && modalProps.modalActions}
            modalTitle={modalProps?.modalTitle && modalProps.modalTitle}
            isBorderRadiusVisible={true}
            isInsideClosingButtonVisible={false}
            isOutsideClosingButtonVisible={true}
            modalInnerContainerStyles={ServiceModalInnerContainerStyles}
        />
    );
}
